// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"

const CONFIG = {
  slideTime: 5000,
  animationTime: 500, // when changed adapt in CSS also
}


export default class SlidingHeadlineController extends AdvancedController {

  static targets = [
    "highlight"
  ];

  static values = {
    highlightIndex: {
      type: Number,
      default: 0
    }
    ,
    highlightHeight: {
      type: Number,
      default: 0
    }
    // TODO: use or remove
    // exampleString: String,
    // exampleDefault: { type: Number, default: 42 },
  }

  connect() {
    super.connect(...arguments)

    setTimeout(this.initialHighlight.bind(this)) // first slide after half time
  }

  moveHighlight() {
    this.highlightIndexValue = (this.highlightIndexValue + 1) % this.highlightTargets.length;

    if (this.highlightTargets.length > 1) {
      this.highlightTargets.forEach((span, index) => {

        if (index === this.highlightIndexValue) {
          // span.classList.remove("-out")
          span.classList.add("-active")
          this.highlightHeight = [span.offsetHeight / 16, 'rem'].join('');
          span.parentElement.style.height = this.highlightHeight;


        } else {
          if (span.classList.contains('-active')) {
            span.classList.add("-out")
            span.classList.remove("-active")
            setTimeout(() => {
              span.classList.remove("-out")
            }, CONFIG.animationTime * 2) // wait for animation to start, half time to crossfade
          }
        }
      })
      setTimeout(this.moveHighlight.bind(this), CONFIG.slideTime)

    }
  }

  initialHighlight() {

    const span = this.highlightTargets[0];
    if (span) {
      span.classList.add("-active")
      this.highlightHeight = [span.offsetHeight / 16, 'rem'].join('');
      span.parentElement.style.height = this.highlightHeight;
    }
    setTimeout(this.moveHighlight.bind(this), CONFIG.slideTime);
  }

}
